import React, { useState, useEffect, useRef } from "react";
import MainPageTextEditor, {
  FormattedMainPageText,
  useMainPageText,
} from "../MainPageTextEditor";
import "./style.css";

const TESTIMONIAL_META = [
  {
    id: 1,
    textKey: "testimonialOne",
    name: "Andrei Ionescu",
    role: "Antreprenor",
    initials: "AI",
    rating: 5,
  },
  {
    id: 2,
    textKey: "testimonialTwo",
    name: "Maria Popescu",
    role: "Profesoară",
    initials: "MP",
    rating: 5,
  },
  {
    id: 3,
    textKey: "testimonialThree",
    name: "Elena Dumitrescu",
    role: "Designer",
    initials: "ED",
    rating: 5,
  },
];

const DEFAULT_TEXT = {
  testimonialOne:
    "„În sfârșit m-am simțit bine în concediu. Cu uleiurile și probioticul folosite zilnic, nu am mai avut probleme cu stomacul și m-am putut bucura de tot fără griji.”",
  testimonialTwo:
    '"Pentru prima dată, menstruația a fost fără dureri și fără stările acelea epuizante cu care eram obișnuită. Folosesc absorbante naturale și *Blendul pentru feminitate*, iar diferența este incredibilă."',
  testimonialThree:
    '"De când folosesc crema cu uleiuri esențiale, tenul meu s-a schimbat complet. Nu mai am coșuri, iar un punct de grăsime de lângă ochi, pe care îl aveam de ani de zile, s-a estompat vizibil fără niciun alt tratament."',
};

const TEXT_FIELDS = [
  { key: "testimonialOne", label: "Testimonial 1", rows: 4 },
  { key: "testimonialTwo", label: "Testimonial 2", rows: 4 },
  { key: "testimonialThree", label: "Testimonial 3", rows: 4 },
];

const PloomTestimonials = () => {
  const [current, setCurrent] = useState(0);
  const [authorVisible, setAuthorVisible] = useState(false);
  const sectionRef = useRef(null);
  const [content, setContent] = useMainPageText("testimonials", DEFAULT_TEXT);
  const testimonials = TESTIMONIAL_META.map((testimonial) => ({
    ...testimonial,
    text: content[testimonial.textKey],
  }));

  const goTo = (index) => setCurrent(index);
  const goPrev = () =>
    setCurrent((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  const goNext = () =>
    setCurrent((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setAuthorVisible(true);
      },
      { threshold: 0.3 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const testimonial = testimonials[current];

  return (
    <section className="new-testimonials main-page-text-editable" ref={sectionRef}>
      <MainPageTextEditor
        section="testimonials"
        sectionLabel="Testimoniale"
        fields={TEXT_FIELDS}
        value={content}
        onSaved={setContent}
      />
      <div className="new-testimonials__inner">
        <div className="new-testimonials__header">
          <span className="new-testimonials__pre-title">
            TESTIMONIALE
          </span>
          <h2 className="new-testimonials__title">Ce spun</h2>
          <p className="new-testimonials__subtitle">clienții noștri</p>
        </div>

        <div className="new-testimonials__slider">
          <button
            className="new-testimonials__arrow new-testimonials__arrow--prev"
            onClick={goPrev}
            aria-label="Previous"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>

          <div className="new-testimonials__card" key={testimonial.id}>
            <div className="new-testimonials__quote-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>
            </div>

            <p className="new-testimonials__text">
              <FormattedMainPageText text={testimonial.text} />
            </p>

            {/* <div
              className={`new-testimonials__author ${
                authorVisible ? "new-testimonials__author--visible" : ""
              }`}
            >
              <div className="new-testimonials__avatar">
                {testimonial.initials}
              </div>
              <div>
                <div className="new-testimonials__name">{testimonial.name}</div>
                <div className="new-testimonials__role">{testimonial.role}</div>
              </div>
            </div> */}
          </div>

          <button
            className="new-testimonials__arrow new-testimonials__arrow--next"
            onClick={goNext}
            aria-label="Next"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        </div>

        <div className="new-testimonials__dots">
          {testimonials.map((_, i) => (
            <button
              key={i}
              className={`new-testimonials__dot ${
                i === current ? "new-testimonials__dot--active" : ""
              }`}
              onClick={() => goTo(i)}
              aria-label={`Go to testimonial ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PloomTestimonials;
